import React from 'react';
import { Link } from 'gatsby';
import Card from './Card';
import parse from 'html-react-parser';


function BlogList({customer}){
  if(!customer.featured_media){
    customer.featured_media = {
      source_url: "https://www.youmagine.com/assets/placeholder.png"
    }
  }

  const date = new Intl.DateTimeFormat('id-ID', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  }).format(new Date(customer.date))

  return (  
    <Card className="mb-8">
      <img src={customer.featured_media.source_url} />
      <Link to={'/blog/' + customer.slug}>
        <p className="text-xl font-semibold mb-1">{customer.title}</p>
      </Link>
      <p className="text-sm">
        {date}  
      </p>
      <div className="mt-6 mb-0" dangerouslySetInnerHTML={{__html: customer.excerpt}} />
      <Link to={'/blog/' + customer.slug}>
        <p className="text-base font-semibold mb-1">Baca selengkapnya</p>
      </Link>
      
      {/* <div className="flex items-center mt-8">
        <img
          className="w-12 h-12 mr-4 rounded-full"
          src={customer.customerImage}
          alt={customer.customerName}
        />
        <div>
          <p>{customer.customerName}</p>
          <p className="text-sm text-gray-600">{customer.customerTitle}</p>
        </div>
      </div> */}
    </Card>
  )
}

export default BlogList;